import * as Scrivito from "scrivito";
import FontAwesomeSelector from "^/Components/ScrivitoExtensions/FontAwesomeSelector";

Scrivito.provideEditingConfig("NavigationElementWidget", {
  title: "Navigation Element",
  attributes: {
    link: {
      title: "Direct link",
      description:
        "If item selected it will navigate directly to the page and dropdow navigation  with items will not open",
    },
    headline: {
      title: "Headine",
    },
    items: {
      title: "Items",
      description: "Items shown as Button",
    },
    subItems: {
      title: "More Items",
      description: "Items shwon as Link underneath the itembuttons",
    },
  },
  properties: ["link", "headline", "items", "subItems"],
  propertiesGroups: [
    {
      title: "Select Icon",
      key: "icon_selector",
      component: ({ widget }) => (
        <FontAwesomeSelector widget={widget} value={widget.get("iconCss")} />
      ),
    },
  ],

  initialContent: {
    headline: "Lorem Ipsum",
    icon: "car",
  },
});
